/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkParcToRisqueCommandDto
 */
export interface LinkParcToRisqueCommandDto {
    /**
     * 
     * @type {string}
     * @memberof LinkParcToRisqueCommandDto
     */
    riskId: string;
    /**
     * 
     * @type {string}
     * @memberof LinkParcToRisqueCommandDto
     */
    parcId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkParcToRisqueCommandDto
     */
    includedRealEstateIds?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof LinkParcToRisqueCommandDto
     */
    effectiveDate?: Date | null;
}

/**
 * Check if a given object implements the LinkParcToRisqueCommandDto interface.
 */
export function instanceOfLinkParcToRisqueCommandDto(value: object): value is LinkParcToRisqueCommandDto {
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    if (!('parcId' in value) || value['parcId'] === undefined) return false;
    return true;
}

export function LinkParcToRisqueCommandDtoFromJSON(json: any): LinkParcToRisqueCommandDto {
    return LinkParcToRisqueCommandDtoFromJSONTyped(json, false);
}

export function LinkParcToRisqueCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkParcToRisqueCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'riskId': json['riskId'],
        'parcId': json['parcId'],
        'includedRealEstateIds': json['includedRealEstateIds'] == null ? undefined : json['includedRealEstateIds'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
    };
}

export function LinkParcToRisqueCommandDtoToJSON(json: any): LinkParcToRisqueCommandDto {
    return LinkParcToRisqueCommandDtoToJSONTyped(json, false);
}

export function LinkParcToRisqueCommandDtoToJSONTyped(value?: LinkParcToRisqueCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskId': value['riskId'],
        'parcId': value['parcId'],
        'includedRealEstateIds': value['includedRealEstateIds'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate'] as any).toISOString()),
    };
}

